import { render, staticRenderFns } from "./NumericField.vue?vue&type=template&id=5d036d1c&scoped=true"
import script from "./NumericField.vue?vue&type=script&lang=js"
export * from "./NumericField.vue?vue&type=script&lang=js"
import style0 from "./NumericField.vue?vue&type=style&index=0&id=5d036d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d036d1c",
  null
  
)

export default component.exports